import styles from "./EditContainer.module.scss";

export const EditContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.editContainer}>{children}</div>;
};
